import { FreeServicesRequestSearchFormComponent } from './free-services-request-search-form.component';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query/dist/npm/filtering/filter-descriptor.interface';
import { FilterOperator } from '@progress/kendo-data-query/dist/npm/filtering/operators.enum';
import { FilterOperatorType } from '../../gk-dynamic-list/gk-dynamic-list.model';
import { GridActionButtonsConfig } from '../../gk-kendo';
import {
  iwIconCheckmark,
  iwIconCross,
} from '../../assets/css/ewid-svg/svg-icons';

export enum FreeServicesRequestSearchFormControlName {
  OfficeNumber = 'officeNumber',
  StartDateFrom = 'startDateFrom',
  StartDateTo = 'startDateTo',
  ExecDateFrom = 'execDateFrom',
  ExecDateTo = 'execDateTo',
  HasDocumentation = 'hasDocumentation',
  Status = 'status',
}
export class FreeServicesRequestSearchFormModel {
  constructor(
    public officeNumber: string,
    public startDateFrom: string,
    public startDateTo: string,
    public execDateFrom: string,
    public execDateTo: string,
    public status: string,
    public hasDocumentation: string,
  ) {}

  static getEmptyModel(): FreeServicesRequestSearchFormModel {
    return new this(null, null, null, null, null, null, null);
  }

  static fromAppToApi(
    data: FreeServicesRequestSearchFormModel,
    displayRequestArchive?: boolean,
    geom?: string,
  ): CompositeFilterDescriptor {
    const filters = [
      {
        field: FreeServicesRequestSearchApiFields.Number,
        operator: FilterOperator.Contains,
        value: data.officeNumber,
        ignoreCase: true,
      },
      {
        field: FreeServicesRequestSearchApiFields.StartDate,
        operator: FilterOperator.GreaterThanOrEqual,
        value: data.startDateFrom,
      },
      {
        field: FreeServicesRequestSearchApiFields.StartDate,
        operator: FilterOperator.LessThanOrEqual,
        value: data.startDateTo,
      },
      {
        field: FreeServicesRequestSearchApiFields.Status,
        operator: FilterOperatorType.InList,
        value: data.status,
        ignoreCase: true,
      },
      {
        field: FreeServicesRequestSearchApiFields.ExecDate,
        operator: FilterOperator.GreaterThanOrEqual,
        value: data.execDateFrom,
      },
      {
        field: FreeServicesRequestSearchApiFields.ExecDate,
        operator: FilterOperator.LessThanOrEqual,
        value: data.execDateTo,
      },
      {
        field: FreeServicesRequestSearchApiFields.Docs,
        operator: FilterOperator.EqualTo,
        value: data.hasDocumentation,
      },
      ...(geom
        ? [
            {
              field: FreeServicesRequestSearchApiFields.SelectRange,
              operator: 'Intersects',
              value: geom,
            },
          ]
        : []),
      ...(displayRequestArchive
        ? [
            {
              field: FreeServicesRequestSearchApiFields.TimeActive,
              operator: FilterOperator.EqualTo,
              value: true,
            },
            {
              field: FreeServicesRequestSearchApiFields.StatusRejected,
              operator: FilterOperator.EqualTo,
              value: false,
            },
          ]
        : []),
    ];

    return {
      logic: 'and',
      filters: filters.filter(
        (element) => element.value !== undefined && element.value !== null,
      ),
    };
  }
}

export enum FreeServicesRequestSearchApiFields {
  Number = 'Numer',
  StartDate = 'DataRozpocz',
  Status = 'PrzpStatus',
  ExecDate = 'DataZalatw',
  Docs = 'Dokumenty',
  TimeActive = 'CzasDostepuWgladActive',
  StatusRejected = 'PrzpStatusRejected',
  SelectRange = 'PrzpGeom',
}

export const freeServicesRequestSearchFormModel =
  FreeServicesRequestSearchFormModel.getEmptyModel();

export function freeServicesRequestSearchFormActionButtonsConfig(
  c: FreeServicesRequestSearchFormComponent,
): GridActionButtonsConfig {
  return {
    actionsLayout: 'end',
    buttons: [
      {
        text: 'CLEAR_FILTER',
        iconClass: 'fa fa-eraser',
        click: () => c.clearForm(),
      },
      {
        text: 'APPLY_FILTER',
        type: 'submit',
        svgIcon: iwIconCheckmark,
        className: 'svg-icon-color-info',
      },
      {
        text: 'DISMISS',
        svgIcon: iwIconCross,
        className: 'svg-icon-red',
        click: () => c.onCancel(),
      },
    ],
  };
}
